module.exports = __webpack_public_path__ + "img/3-3.ced2beb0.svg";